<button
	class="story"
	[ngClass]="{ 'story--not-viewed': !story.isViewed }"
	(click)="handleStoryClick()"
>
	<div class="story__content">
		<app-adaptive-image
			class="splash-banner__image"
			[image]="story.lightTheme"
		></app-adaptive-image>
	</div>
</button>
